var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchResultsArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 23,
  viewBox: "0 0 33 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 9.5459C0.671573 9.5459 0 10.2175 0 11.0459C0 11.8743 0.671573 12.5459 1.5 12.5459V11.0459V9.5459ZM32.4037 12.1066C32.9895 11.5208 32.9895 10.571 32.4037 9.98524L22.8577 0.439297C22.2719 -0.14649 21.3222 -0.14649 20.7364 0.439297C20.1506 1.02508 20.1506 1.97483 20.7364 2.56062L29.2217 11.0459L20.7364 19.5312C20.1506 20.117 20.1506 21.0667 20.7364 21.6525C21.3222 22.2383 22.2719 22.2383 22.8577 21.6525L32.4037 12.1066ZM1.5 11.0459V12.5459H31.343V11.0459V9.5459H1.5V11.0459Z",
  fill: "white"
})));
export default SvgSearchResultsArrow;